export interface IRow {
	rowId: number;
	item: any;
}

export const createRows = (itemsFiltered: any[]) => {
	return itemsFiltered.map((x, ii) => ({
		rowId: ii,
		item: x,
	})) as IRow[];
};
